export default (state = [], action) => {
    switch (action.type) {
        case 'FETCH_UNIQUE_USERS_COUNTS_DATA':
            return action.payload;
        default:
            return state;
    }
};